import React from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import HelpCenterPopupComponent from "./HelpCenterPopupComponent";

import { audienceInteractionData } from "../../Api/help-center-json-data/audience-interaction";
import HelpCenterTitleComponent from "./HelpCenterTitleComponent";

const AudienceInteractionTabComponent = () => {
  const styles = useStyles();

  return (
    <>
      <HelpCenterTitleComponent
        title={audienceInteractionData.AudienceInteraction.Title}
      />
      <View
        style={{
          backgroundColor: AppColors.appBlueColor_3A5175,
          borderRadius: 10,
          padding: 20,
        }}
      >
        <View style={{ gap: 20 }}>
          <View style={styles.contentContainer}>
            <HelpCenterPopupComponent
              steps={audienceInteractionData.AudienceInteraction.Steps}
              topData={
                audienceInteractionData.AudienceInteraction.GeneralTopData
              }
              bottomData={
                audienceInteractionData.AudienceInteraction.GeneralBottomData
              }
            />
          </View>
        </View>
      </View>
    </>
  );
};

export default AudienceInteractionTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    tabContainer: {
      flexDirection: "row",
      gap: 20,
    },
    tabButton: {
      alignItems: "center",
      paddingVertical: 8,
      flexDirection: "row",
      backgroundColor: AppColors.gray_6E90B4,
      justifyContent: "space-between",
      paddingHorizontal: 10,
      borderRadius: 10,
      width: 154,
      height: 45,
    },

    contentContainer: {
      marginTop: 10,
      paddingHorizontal: 10,
    },
    arrowIcon: {
      width: 10,
      height: 5,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: { tabButton: { height: 29, width: 140 } },
    [DEVICE_SIZES.XS]: { tabButton: { height: 29, width: 140 } },
  }
);
